class AccordionGallery {
    constructor(container) {
        if (!container) return;
        this.container = container;
        this.accordionHeaders = container.querySelectorAll('.accordion-header');
        this.accordionContents = container.querySelectorAll('.accordion-content');
        this.images = container.querySelectorAll('.main-image');
        this.init();
    }

    async init() {
        await Promise.all(
            Array.from(this.images).map(
                (img) =>
                    new Promise((resolve) => {
                        if (img.complete) resolve();
                        img.onload = () => resolve();
                        img.onerror = () => resolve();
                    })
            )
        );

        gsap.registerPlugin(ScrollTrigger);
        this.setupParallax();
        this.setupEntryAnimation();
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.accordionHeaders.forEach((header) => {
            header.addEventListener('click', () => {
                const index = parseInt(header.dataset.index);
                this.animate(index);
            });
        });
    }

    setupEntryAnimation() {
        gsap.to(this.accordionHeaders, {
            opacity: 1,
            duration: 0.4,
            ease: 'power2.out',
            scrollTrigger: {
                trigger: this.container,
                start: 'top 95%',
                end: 'top 70%',
                toggleActions: 'play none none',
                once: true,
                onEnter: () => {
                    setTimeout(() => {
                        this.container.querySelector('.accordion-header')?.click();
                    }, 100);
                },
            },
        });
    }

    async animate(index) {
        const newImage = Array.from(this.images).find((img) => parseInt(img.dataset.index) === index);

        await new Promise((resolve) => setTimeout(resolve, 100));

        const currentImage = this.container.querySelector('.main-image.active');
        if (currentImage) {
            currentImage.style.transitionDelay = '0s';
            currentImage.classList.remove('active');
        }

        await new Promise((resolve) => setTimeout(resolve, 300));

        this.accordionContents.forEach((content) => {
            content.classList.remove('active');
            content.style.height = '0px';
        });

        const activeContent = this.accordionContents[index];
        activeContent.classList.add('active');
        activeContent.style.height = `${activeContent.scrollHeight}px`;

        await new Promise((resolve) => setTimeout(resolve, 200));

        if (newImage) {
            newImage.style.transitionDelay = '0s';
            newImage.classList.add('active');
        }
    }

    setupParallax() {
        this.images.forEach((img) => {
            gsap.to(img, {
                y: 100,
                ease: 'none',
                scrollTrigger: {
                    trigger: img.closest('.image-with-text__media'),
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: 1,
                    toggleActions: 'play none none reverse',
                },
            });
        });
    }
}

// Initialize galleries
if (!window.accordionGalleriesInitialized) {
    window.accordionGalleriesInitialized = true;

    function initAccordionGalleries() {
        document.querySelectorAll('.section-image-with-list').forEach(container => {
            new AccordionGallery(container);
        });
    }

    // Handle initial load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAccordionGalleries);
    } else {
        initAccordionGalleries();
    }

    // Handle Shopify section updates
    if (Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (event) => {
            const container = event.target.querySelector('.section-image-with-list');
            if (container) {
                new AccordionGallery(container);
            }
        });
    }
} 